import { node_observable_component } from 'common/util/ComponentDecorator';
import './review-reply-form.scss';

@node_observable_component
export default class ReviewReplyForm {
	static classname = 'review-reply-form';

	constructor($reply_form) {
		this.$reply_form = $reply_form;

		this.bindEvents();
	}

	get append_to() {
		return this.$reply_form.data('append_to');
	}

	get append_closest() {
		return this.$reply_form.data('append_closest');
	}

	get $append_to() {
		return this.$reply_form.closest(this.append_closest).find(this.append_to);
	}

	get $form() {
		return this.$reply_form.find('.review-reply-form__form');
	}

	get $submit() {
		return this.$reply_form.find('.review-reply-form__submit-btn');
	}

	get $error() {
		return this.$reply_form.find('.review-reply-form__error');
	}

	get is_disabled() {
		return this.$submit.hasClass('btn--disabled');
	}

	set is_disabled(state) {
		this.$submit.toggleClass('btn--disabled', state);
	}

	/**
	 * @return {FormData}
	 */
	get form_data() {
		return new FormData(this.$form[0]);
	}

	get form_url() {
		return this.$form.attr('action');
	}

	bindEvents() {
		this.$form.on('submit', this.handleSubmit);

		this.$reply_form.find('.review-reply-form__submit-btn').on('click', () => {
			this.$form.trigger('submit');
		});

		this.$reply_form.find('.review-reply-form__cancel-btn').on('click', () => {
			this.$reply_form.trigger('cancel');
		});
	}

	handleSubmit = e => {
		if (this.is_disabled) {
			e.preventDefault();
			return false;
		}

		this.is_disabled = true;

		$.ajax({
			url: this.form_url,
			type: 'POST',
			data: this.form_data,
			cache: false,
			contentType: false,
			processData: false
		}).then(this.handleAjaxSuccess);

		e.preventDefault();
		return false;
	};

	handleAjaxSuccess = response => {
		this.is_disabled = false;
		this.$error.empty();

		if (response.status === 'ok') {
			ModalUtil.openContent($(window.product_review_form_result.success));
			if (response.data.html) {
				const $html = $(response.data.html);
				this.$append_to.append($html);
			}

			this.$reply_form.trigger('success');
		} else if (response.status === 'fail') {
			this.$reply_form.trigger('error');

			let { errors } = response;
			if (!errors) {
				alert('Произошла неизвестная ошибка при попытке отправки формы');
				return;
			}

			$.each(errors, (name, message) => {
				const $field = this.$form.find(`[data-field="${name}"]`);
				if ($field.length) {
					const $formgroup = $field.closest('.formgroup');

					let $formgroup_error = $formgroup.find('.formgroup__error');
					if (!$formgroup_error.length) {
						$formgroup_error = $('<div class="formgroup__error"/>');
						$formgroup.append($formgroup_error);
					}
					$formgroup_error.html(message);
					$formgroup.addClass('formgroup--error');
					$field.trigger('focus');
				} else {
					this.$error.append($('<div/>').html(message));
				}
			});
		}
	};
}
